import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { cn } from 'lib/utils';
import { ReactSVG } from 'react-svg';
import { add_user_grey_icon, plus_grey_icon, quick_action_icon, total_audit_icon } from 'asset/icons';
import DashboardFunctional from "./index.function"
import DatePicker from 'components/DatePicker';
import { Button } from 'components/ui/button';

interface StatCardProps {
  title: string;
  value: number | string;
  description: string;
  icon?: string;
  className?: string;
}

interface QuickActionCardProps {
  title: string;
  icon?: string;
  onClick: () => void;
}

const Dashboard = () => {

  const {
    navigate,
    states,
    fromDate,
    setFromDate,
    setToDate,
    toDate,
    onFilter,
    onReset
  } = DashboardFunctional();

  return (
    <Wrapper>
      <div className='mb-6'>
        <Text text='Dashboard' size={fontSizes.h28} className='font-bold' />
        <Text text='Welcome back!' className=' jtext-muted-foreground' />
      </div>

      <div className='flex flex-col md:flex-row gap-3 mb-5 items-end'>
        <DatePicker
          label='From Date'
          value={fromDate}
          onChange={setFromDate}
          className='md:w-1/3'
          maxDate={new Date()}
        />
        <DatePicker
          label='To Date'
          value={toDate}
          onChange={setToDate}
          className='md:w-1/3'
          minDate={fromDate ?? null}
          maxDate={new Date()}
        />


        <Button className={cn('md:w-[12%] rounded-lg', 'bg-primary hover:bg-primary/90 ')}
          onClick={onFilter}>
          {"Filter"}
        </Button>
        <Button
          variant='outline'
          className='md:w-[12%] rounded-lg border-primary text-primary hover:bg-primary/10'
          onClick={onReset}
        >
          {"Reset"}
        </Button>

      </div>


      <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-6'>
        <StatCard title='Total Audits' value={states?.totalAudits ?? 0} description='Total audits completed' icon={total_audit_icon} />
        <StatCard title='Ongoing Audits' value={states?.pendingAudits ?? 0} description='Audits currently in progress' icon={total_audit_icon} />
        <StatCard title='Completed Audits' value={states?.completedAudits ?? 0} description='All audits finished' icon={total_audit_icon} />
      </div>

      {/* <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-8'>
        <StatCard title='Pending Reports' value={10} description='Reports in progress' icon={pending_report_icon} className='md:col-span-1' />
      </div> */}

      <div className='rounded-xl border bg-white p-5 shadow-md mb-8'>
        <div className='flex flex-row align-middle gap-2' >
          <ReactSVG className='mt-1' src={quick_action_icon} />
          <Text text='Quick Action' className='font-semibold mb-4' size={fontSizes.h16} />
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <QuickActionCard title='Create New Audit' icon={plus_grey_icon} onClick={() => navigate('/audits')} />

          <QuickActionCard title='Add User' icon={add_user_grey_icon} onClick={() => navigate('/users')} />

          <QuickActionCard title='Add Customer' icon={add_user_grey_icon} onClick={() => navigate('/customers')} />
        </div>
      </div>
    </Wrapper>
  );
};

export default Dashboard;

const StatCard = ({ title, value, description, icon, className }: StatCardProps) => {
  return (
    <div className={cn('rounded-xl border bg-white p-5 flex justify-between items-start shadow-md', className)}>
      <div>
        <Text text={title} className='text-muted-foreground' size={fontSizes.h14} />
        <Text text={String(value)} className='font-bold mt-2' size={fontSizes.h26} />
        <Text text={description} className='text-muted-foreground mt-1' size={fontSizes.h12} />
      </div>

      <ReactSVG src={icon} />
    </div>
  );
};

const QuickActionCard = ({ title, icon, onClick }: QuickActionCardProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'rounded-xl border bg-white p-5 flex items-center justify-between cursor-pointer',
        'hover:border-primary hover:bg-primary/5 transition-all',
      )}
    >
      <Text text={title} size={fontSizes.h14} className='font-medium' />
      <ReactSVG src={icon} />
    </div>
  );
};
